import { fetchCall, fetchLoginCall, fetchNoCall } from '../utils/ajax';
import { API_CONSTANTS, API_METHODS } from '../constants/api-constants';


export const Login = (callback, payload) => {
    const url = `${API_CONSTANTS.LOGIN}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.PUT, payload);
};

export const getRefreshToken = (callback, payload) => {
    const url = `${API_CONSTANTS.GET_REFRESH_TOKEN}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.PUT, payload);
};

export const GetAllOTP = (callback, payload) => {
    const url = `${API_CONSTANTS.GET_ALL_OTP}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.GET, payload);
};

export const getCountriesList = (callback, payload) => {
    const url = `${API_CONSTANTS.GET_COUNTRIES_LIST}`;
    return fetchCall((response) => {
        callback(response);
    }, url, API_METHODS.GET, payload);
};

export const getStateList = (callback, payload) => {
    let queryString = `?countryId=${payload}`
    const url = `${API_CONSTANTS.GET_STATE_LIST + queryString}`;
    return fetchCall((response) => {
        callback(response);
    }, url, API_METHODS.GET);
};

export const getCityList = (callback, payload) => {
    let queryString = `?stateId=${payload}`
    const url = `${API_CONSTANTS.GET_CITY_LIST + queryString}`;
    return fetchCall((response) => {
        callback(response);
    }, url, API_METHODS.GET);
};

export const GenderMaster = (callback, payload) => {
    const url = `${API_CONSTANTS.GET_GENDER_MASTER}`;
    return fetchCall((response) => {
        callback(response);
    }, url, API_METHODS.GET, payload);
};

export const Register = (callback, payload) => {
    const url = `${API_CONSTANTS.REGISTER}`;
    return fetchCall((response) => {
        callback(response);
    }, url, API_METHODS.POST, payload);
};

export const GetAllEmployee = (callback, payload) => {
    const url = `${API_CONSTANTS.GET_ALL_EMPLOYEE}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.POST, payload);
};

export const GetAllEmployeeDetails = (callback, payload) => {
    const url = `${API_CONSTANTS.GET_ALL_EMPLOYEE_DETAILS}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.GET, payload);
};

export const VerifyUser = (callback, payload) => {
    let queryString = `?userId=${payload.userId}&isActive=${payload.isActive}`
    const url = `${API_CONSTANTS.VERIFY_USER + queryString}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.POST);
};


export const DeleteEmployee = (callback, payload) => {
    let queryString = `?userId=${payload.userId}`
    const url = `${API_CONSTANTS.DELETE_EMPLOYEE + queryString}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.DELETE);
};

export const AddEmployee = (callback, payload) => {
    const url = `${API_CONSTANTS.ADD_EMPLOYEE}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.POST, payload);
};

export const EditEmployee = (callback, payload) => {
    const url = `${API_CONSTANTS.EDIT_EMPLOYEE}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.POST, payload);
};

export const GetAllEmployeeDetailsbyId = (callback, payload) => {
    let queryString = `?userId=${payload.userId}`
    const url = `${API_CONSTANTS.GET_ALL_EMPLOYEE_DETAILS_BY_ID + queryString}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.GET);
};

export const GetAllServiceAuth = (callback, payload) => {
    // let queryString = `?searchString=${payload.searchString}`
    const url = `${API_CONSTANTS.GET_ALL_SERVICE_AUTH}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.GET);
};

export const UpdateFlags = (callback, payload) => {
    let queryString = `?isFixedInitiated=${payload.isFixedInitiated}&isBlocked=${payload.isBlocked}&id=${payload.id}`
    const url = `${API_CONSTANTS.UPDATE__FLAGS + queryString}`;
    return fetchLoginCall((response) => {
        callback(response);
    }, url, API_METHODS.GET);
};

export const getLogs = (callback, payload) => {
    let queryString = `?startDate=${payload.startDate}&endDate=${payload.endDate}&userId=${payload.userId}`
    const url = `${API_CONSTANTS.Get_Logs + queryString}`;
    return fetchNoCall((response) => {
        callback(response);
    }, url, API_METHODS.GET, payload);
};